import axios from "axios";

export const doQuote = async (parameters, token, variant) => {
  const config = {
    headers:{
      'Accept'        : 'application/json',
      'Content-Type'  : 'application/json',
    }
  }
  
  const body = {
    parameters,
    authenticity_token: token,
    variant_id: variant,
  }

  return axios.post(`${Spree.routes.product_quote_url}`, body, config).then(response => response.data)
}

export const doReQuote = async (parameters, token, variant, quoteNumber) => {
  const config = {
    headers:{
      'Accept'        : 'application/json',
      'Content-Type'  : 'application/json',
    }
  }
  
  const body = {
    parameters,
    authenticity_token: token,
    variant_id: variant,
  }

  return axios.put(`${Spree.routes.product_quote_url}/${quoteNumber}`, body, config).then(response => response.data)
}
